import TVHeader from '../../images/tv-header.png'

export default function Header() {
    return (
        <div className="">
            <img className="tv-header" src={TVHeader} alt="TradingView Header" />
        </div>
    )
}